<template>
  <div
      class="info-block"
      @mouseenter="hoverMode && onHoverEnter()"
      @mouseleave="hoverMode && onHoverLeave()"
  >
    <button
        class="info-block__trigger"
        type="button"
        :aria-label="ariaLabel"
        :aria-expanded="isContentVisible ? 'true' : 'false'"
        @click="onTriggerClick"
    >
      <span aria-hidden="true">{{ triggerLabel }}</span>
    </button>

    <div
        v-if="isContentVisible && !hoverMode"
        class="info-block__backdrop"
        aria-hidden="true"
        @click="closeContent"
    ></div>

    <div v-if="isContentVisible" class="info-block__block">
      <button
          v-if="!hoverMode"
          type="button"
          class="info-block__close"
          @click="closeContent"
      >
      </button>
      <slot />
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";

export default {
  name: "InfoBlock",
  props: {
    hoverMode: {
      type: Boolean,
      default: false,
    },
    /** Текст на кнопке (например «i» или «?») */
    triggerLabel: {
      type: String,
      default: '?',
    },
    ariaLabel: {
      type: String,
      default: 'Подробная информация',
    },
  },
  data() {
    return {
      isContentVisible: false,
      hoverTimeout: null,
    };
  },
  mounted() {
    EventBus.on("closeAll", this.closeContent);
  },
  unmounted() {
    EventBus.off("closeAll", this.closeContent);
  },
  methods: {
    onTriggerClick() {
      if (this.hoverMode) {
        return;
      }
      this.toggleContent();
    },
    toggleContent() {
      if (!this.isContentVisible) {
        EventBus.emit("closeAll");
      }
      this.isContentVisible = !this.isContentVisible;
    },
    onHoverEnter() {
      this.clearHoverTimeout();
      EventBus.emit("closeAll");
      this.isContentVisible = true;
    },
    onHoverLeave() {
      this.clearHoverTimeout();
      this.hoverTimeout = setTimeout(() => {
        this.isContentVisible = false;
        this.hoverTimeout = null;
      }, 200);
    },
    closeContent() {
      this.clearHoverTimeout();
      this.isContentVisible = false;
    },
    clearHoverTimeout() {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
    },
  },
};
</script>

<style scoped>
.info-block__backdrop {
  position: fixed;
  inset: 0;
  z-index: 5;
  cursor: default;
  background: rgba(1, 20, 108, 0.22);
}

.info-block__trigger {
  position: relative;
  z-index: 20;
}
</style>
